<div class="toolbar-content">
    <ng-content select="slot-toolbar-left"></ng-content>
    <ng-content select="slot-toolbar-middle"></ng-content>
    <ng-content select="slot-toolbar-right"></ng-content>
</div>
